import { Suspense, lazy } from 'react';

import { DynamicBaseBreadcrumb, DynamicDomainsBreadcrumb } from '../../modules/AppBreadcrumb';
import { Spinner } from '../components';
import { AppControllerType, AppRoutes } from '../interfaces/router';

const DomainsListPage = lazy(() => import('../../pages/Domains/DomainsList.page'));
const DomainsDossierPage = lazy(() => import('../../pages/Domains/DomainsDossier.page'));
const DomainConfigCreatePage = lazy(() => import('../../pages/Domains/DomainConfigCreate.page'));
const DomainConfigEditPage = lazy(() => import('../../pages/Domains/DomainConfigEdit.page'));
const DomainsCreatePage = lazy(() => import('../../pages/Domains/DomainsCreate.page'));
const DomainsEditPage = lazy(() => import('../../pages/Domains/DomainsEdit.page'));

export const DomainsController: AppControllerType = {
  common: [
    {
      path: AppRoutes.Domains + '/*',
      element: (
        <Suspense fallback={ <Spinner/> }>
          <DomainsListPage/>
        </Suspense>
      ),
      breadcrumb: DynamicDomainsBreadcrumb.DynamicDomainsListBreadcrumb
    }
  ],
  drawer: [
    {
      path: AppRoutes.DomainsById,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <DomainsDossierPage/>
        </Suspense>
      ),
      breadcrumb: DynamicDomainsBreadcrumb.DynamicDomainsByIdBreadcrumb,
      props: {
        commonDrawerWidth: 460
      }
    },
    {
      path: AppRoutes.DomainsByIdConfigAttach,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <DomainConfigCreatePage/>
        </Suspense>
      ),
      breadcrumb: DynamicDomainsBreadcrumb.DynamicDomainsConfigBreadcrumb,
      props: {
        commonDrawerWidth: 460
      }
    },
    {
      path: AppRoutes.DomainsByIdConfigEdit,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <DomainConfigEditPage/>
        </Suspense>
      ),
      breadcrumb: DynamicDomainsBreadcrumb.DynamicDomainsConfigBreadcrumb,
      props: {
        commonDrawerWidth: 460
      }
    },
    {
      path: AppRoutes.DomainsCreate,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <DomainsCreatePage/>
        </Suspense>
      ),
      breadcrumb: DynamicBaseBreadcrumb.DynamicBaseCreateBreadcrumb,
      props: {
        commonDrawerWidth: 460
      }
    },
    {
      path: AppRoutes.DomainsEdit,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <DomainsEditPage/>
        </Suspense>
      ),
      breadcrumb: DynamicBaseBreadcrumb.DynamicBaseEditBreadcrumb,
      props: {
        commonDrawerWidth: 460
      }
    }
  ]
};
